import { useMutation } from '@tanstack/react-query';
import { updateSigner } from 'api/tax-delivery';

export function useUpdateSigner() {
  return useMutation({
    mutationFn: updateSigner,
  });
}
